export default "__VITE_ASSET__kJFJjye3__"